module.exports = __webpack_public_path__ + "static/poetry-night-939e0b7801edf11cd616e6ab4954d298.png";